import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import { EventBus } from "../../../event-bus";
import * as emConsts from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";

export const state = {
  filesources: [],
  filesource: {},
  pagination: {
    count: 10,
    total: 0
  }
};

export const getters = {
  [emConsts.GETTERS_LIST_FILESOURCE]: state => {
    return state.filesources;
  },
  [emConsts.GETTERS_FILESOURCE]: state => {
    return state.filesource;
  },
  [emConsts.GETTERS_FILESOURCE_PAGINATION]: state => {
    return state.pagination;
  }
};

export const actions = {
  [emConsts.ACTION_GET_FILESOURCE_LIST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().employers.getFileSources,
      buildOptions("GET", options),
      commit
    )
      .then(response => {
        if (response.data) {
          commit(emConsts.MUTATION_SET_FILESOURCE_LIST, response);
        }
      })
      .catch(function(response) {
        if (!response) {
          return;
        }
        let msg = "Something went wrong";
        if (response.data && response.data.message) {
          msg = response.data.message;
        } else if (response.message) {
          msg = response.message;
        }
        EventBus.$emit(EVENT_ERROR_TOAST_MESSAGE, msg);
      });
  },
  [emConsts.ACTION_GET_FILESOURCE]: ({ commit }, options) => {
    commit(emConsts.MUTATION_SET_FILESOURCE, { data: {} });
    makeCall(
      getEndPoints().employers.getFileSource.replace(
        ":id",
        options.filesource_id
      ),
      buildOptions("GET", options),
      commit
    )
      .then(response => {
        if (response.data) {
          commit(emConsts.MUTATION_SET_FILESOURCE, response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [emConsts.ACTION_SET_FILESOURCE]: ({ commit }, options) => {
    let method = options.isEdit ? "PUT" : "POST";
    let url = options.isEdit
      ? getEndPoints().employers.getFileSource.replace(
          ":id",
          options.filesource_id
        )
      : getEndPoints().employers.addFileSource;
    makeCall(url, buildOptions(method, options.data), commit)
      .then(response => {
        if (response.error) {
          if (options.errorHandling) {
            options.errorHandling(response.error);
          }
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [emConsts.ACTION_DELETE_FILESOURCE]: ({ commit }, options) => {
    let url = getEndPoints().employers.deleteFileSource.replace(
      ":id",
      options.filesource_id
    );
    makeCall(url, buildOptions("DELETE", {}), commit)
      .then(response => {
        if (response.error) {
          if (options.errorHandling) {
            options.errorHandling(response.error);
          }
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  }
};

export const mutations = {
  [emConsts.MUTATION_SET_FILESOURCE_LIST]: (state, filesource) => {
    state.filesources = filesource;
  },
  [emConsts.MUTATION_SET_FILESOURCE]: (state, filesource) => {
    state.filesource = filesource;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/file_source/index.js